import { isObjectLike } from '@scalar/helpers/object/is-object';
const clearedFieldsKey = 'x-scalar-secret-cleared-fields';
const getClearedFields = (secrets) => {
    const fields = Reflect.get(secrets, clearedFieldsKey);
    return Array.isArray(fields) ? fields.filter((field) => typeof field === 'string') : [];
};
/** Legacy empty credentials still inherit defaults; only an explicit clear overrides them. */
export const isSecretFieldCleared = (secrets, field) => getClearedFields(secrets).includes(field);
/** Record clear intent from the update, rather than from empty values filled by the store schema. */
export const updateClearedSecretFields = (secrets, update) => {
    const cleared = new Set(getClearedFields(secrets));
    for (const [field, value] of Object.entries(update)) {
        if (field.startsWith('x-scalar-secret-') && field !== clearedFieldsKey && typeof value === 'string') {
            if (value === '') {
                cleared.add(field);
            }
            else {
                cleared.delete(field);
            }
        }
        else if (isObjectLike(value) && isObjectLike(secrets[field])) {
            updateClearedSecretFields(secrets[field], value);
        }
    }
    if (cleared.size) {
        secrets[clearedFieldsKey] = [...cleared];
    }
    else {
        delete secrets[clearedFieldsKey];
    }
};
/** Release one override so its current document or configured default can take effect. */
export const resetSecretField = (secrets, field) => {
    delete secrets[field];
    const cleared = getClearedFields(secrets).filter((value) => value !== field);
    if (cleared.length) {
        secrets[clearedFieldsKey] = cleared;
    }
    else {
        delete secrets[clearedFieldsKey];
    }
};
